import supportedLocales from "../../config/supported-locales";
import type { AnnotatedLocales } from "./types/supported-locales";

export function getSupportedLocales(): Array<AnnotatedLocales> {
  const annotatedLocales: Array<AnnotatedLocales> = [];

  for (const code of Object.keys(supportedLocales)) {
    const codeS: keyof typeof supportedLocales = code as keyof typeof supportedLocales;
    annotatedLocales.push({
      code: codeS,
      name: supportedLocales[codeS]
    });
  }

  return annotatedLocales;
}
export function supportedLocalesInclude(locale: string) {
  return Object.keys(supportedLocales).includes(locale);
}
